import { render, staticRenderFns } from "./RecognitionButton.vue?vue&type=template&id=0e2b8b7e&"
import script from "./RecognitionButton.vue?vue&type=script&lang=js&"
export * from "./RecognitionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports